import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Routes, RouterModule } from '@angular/router';

import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { ReceipthotelComponent } from './receipthotel/receipthotel.component';
import { EdithotelComponent } from './edithotel/edithotel.component';
import { ListhotelComponent } from './listhotel/listhotel.component';
import { ViewbillComponent } from './viewbill/viewbill.component';
import { PaybillComponent } from './paybill/paybill.component';
import { SerchreportComponent } from './serchreport/serchreport.component';
import { LoginComponent } from './login/login.component';
import { AuthguardGuard } from './authguard.guard';
import { OrderComponent } from './order/order.component';
import { OrderlistComponent } from './orderlist/orderlist.component';
import { UnitsComponent } from './units/units.component';
import { PrintbillComponent } from './printbill/printbill.component';

const routes:Routes = [
  {path:'', component:LoginComponent},
  {path:'setting', canActivate: [AuthguardGuard],  component:HomeComponent},
  {path:'report', canActivate: [AuthguardGuard], component:ListhotelComponent},
  {path:'receipthotel', canActivate: [AuthguardGuard],  component:ReceipthotelComponent},
  {path:'editrate', canActivate: [AuthguardGuard], component:EdithotelComponent},
  {path:'viewbill/:id', canActivate: [AuthguardGuard], component:ViewbillComponent},
  {path:'paybill/:id', canActivate: [AuthguardGuard], component:PaybillComponent},
  {path:'searchreport/:hotelid/:from/:to', canActivate: [AuthguardGuard], component:SerchreportComponent},
  {path:'login', component:LoginComponent},
  {path:'order/:id', canActivate: [AuthguardGuard], component:OrderComponent},
  {path:'orderlist', canActivate: [AuthguardGuard], component:OrderlistComponent},
  {path:'units', canActivate: [AuthguardGuard], component:UnitsComponent},
  {path:'printbill', canActivate: [AuthguardGuard], component:PrintbillComponent},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes ,{ useHash: true })
  ],
  exports:[RouterModule],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/app-routing.module.ts